const underConstructionDictES = {
  comingSoon: 'Próximamente',
  photoBy: 'Foto por',
}

export default underConstructionDictES;